var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Menu } from "semantic-ui-react";
import { Plexity, ProKitConfig } from "../../KitDeserializer";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { findChromogenPresetScale } from "../manual-pro/ManualProConsumerDetectForm";
import { PriceDisplay } from "../rna-fish/EditKitForm";
import { ErrorElementsWithPrices } from "../rna-fish/NewRnaFishKitPage";
import { ProtocolTypeEnum } from "./EditKitForm";
import { chromogenCompatiblePlatform } from "./ProKitDetectForm";
var ChromogenKitForm = /** @class */ (function (_super) {
    __extends(ChromogenKitForm, _super);
    function ChromogenKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onProtocolChange = function (_, data) {
            var pt = data.name;
            var selectedProtocol = _this.props.catalog.proPlatforms.find(function (p) {
                return p.id === pt;
            });
            _this.props.setFormState(function () {
                var _a;
                return ({
                    protocolType: selectedProtocol,
                    presetChromogenScale: findChromogenPresetScale(_this.props.catalog.presetScales, selectedProtocol ? selectedProtocol.id : undefined, _this.props.formState.chromogen, (_a = _this.props.formState.scale) !== null && _a !== void 0 ? _a : _this.props.catalog.defaultAutomatedProScale)
                });
            }, _this.loadPrice);
        };
        _this.onScaleChange = function (_, data) {
            var index = data.index;
            var selectedScale = _this.props.catalog.automatedProScaleOptions[index];
            _this.props.setFormState(function () { return ({
                scale: selectedScale,
                presetChromogenScale: findChromogenPresetScale(_this.props.catalog.presetScales, _this.props.formState.protocolType ? _this.props.formState.protocolType.id : undefined, _this.props.formState.chromogen, selectedScale !== null && selectedScale !== void 0 ? selectedScale : _this.props.catalog.defaultAutomatedProScale)
            }); }, _this.loadPrice);
        };
        _this.onChromogenChange = function (_, data) {
            var cc = data.name;
            var selectedChromogen = _this.props.catalog.proChromogens.chromogens
                .find(function (c) { return c.id === cc; });
            _this.props.setFormState(function () {
                var _a;
                return ({
                    chromogen: selectedChromogen,
                    presetChromogenScale: findChromogenPresetScale(_this.props.catalog.presetScales, _this.props.formState.protocolType ? _this.props.formState.protocolType.id : undefined, selectedChromogen, (_a = _this.props.formState.scale) !== null && _a !== void 0 ? _a : _this.props.catalog.defaultAutomatedProScale)
                });
            }, _this.loadPrice);
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(ChromogenKitForm.serializeChromogenKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElementsWithPrices(json.errors, json.price); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElementsWithPrices) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: resp.price
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    ChromogenKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    ChromogenKitForm.prototype.render = function () {
        var _this = this;
        var protocolType = this.props.formState.protocolType;
        var scale = this.props.formState.scale;
        var chromogen = this.props.formState.chromogen;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 2, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { textAlign: "center", width: 12 },
                        React.createElement("h1", { className: "ish-primary-header" }, "Matisse\u00AE Chromogens"),
                        React.createElement("h1", { className: "ish-subheader" }, "Enhance your HCR\u2122 Pro RNA-ISH Assay")))),
            React.createElement(Grid, { columns: 4, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Platform")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, this.props.catalog.proPlatforms
                            .filter(function (p) { return chromogenCompatiblePlatform(_this.props.catalog.proChromogens.chromogens, p) && p.id !== ProtocolTypeEnum.MANUAL; })
                            .map(function (p, index) {
                            return React.createElement(Menu.Item, { className: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id
                                    ? "half-configure-selection selected-ish" : "half-configure-selection", onClick: _this.onProtocolChange, index: index, fitted: true, key: index, active: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id, name: p.id },
                                React.createElement("p", { className: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id ? "ish-p-tag selected-ish" : "ish-p-tag" }, p.alias === "ONCORE Pro X" ?
                                    React.createElement(React.Fragment, null, "ONCORE Pro\u00A0X") : p.alias));
                        })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Scale")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, this.props.catalog.automatedProScaleOptions.map(function (s, index) {
                            return React.createElement(Menu.Item, { className: s === scale ? "half-configure-selection selected-ish" : "half-configure-selection", onClick: _this.onScaleChange, index: index, fitted: true, key: index, active: scale === s },
                                React.createElement("p", { className: scale === s ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                    s,
                                    " Slides"));
                        })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Chromogen")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, this.props.catalog.proChromogens.chromogens.map(function (c, index) {
                            var _a, _b;
                            return React.createElement(Menu.Item, { className: (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "configure-selection selected-ish" : "configure-selection", name: c.id, key: index, onClick: _this.onChromogenChange },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                    React.createElement("p", { className: ((_a = _this.props.formState.chromogen) === null || _a === void 0 ? void 0 : _a.id) === c.id ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, c.label),
                                    React.createElement("p", { className: ((_b = _this.props.formState.chromogen) === null || _b === void 0 ? void 0 : _b.id) === c.id ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(" + c.enzymeCompatibility + " compatible)")));
                        }))))),
            React.createElement(Grid, { columns: 4, textAlign: "right" },
                React.createElement(Grid.Row, null,
                    React.createElement("br", null)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement("div", { 
                            // apply padding that matches the kit component div padding
                            style: { 'paddingRight': '.5rem' } },
                            React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.subtotalCents : undefined }))))));
    };
    ChromogenKitForm.serializeChromogenKit = function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var kit = {
            protocolType: (_a = state.protocolType) === null || _a === void 0 ? void 0 : _a.id,
            config: ProKitConfig.ExtrasOnly,
            comment: state.comment,
            plexity: Plexity.OnePlex,
            probeSetComponent: [],
            detectComponent: null,
            chromogenComponent: {
                presetScaleId: (_c = (_b = state.presetChromogenScale) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null,
                customScaleSlides: ((_d = state.presetChromogenScale) === null || _d === void 0 ? void 0 : _d.id) == null ? state.scale : null,
                chromogenId: (_e = state.chromogen) === null || _e === void 0 ? void 0 : _e.id,
                chromogenBufferId: (_f = state.chromogen) === null || _f === void 0 ? void 0 : _f.bufferCompatibility.id,
                chromogenScaleUl: (_h = (_g = state.presetChromogenScale) === null || _g === void 0 ? void 0 : _g.chromogenScaleUl) !== null && _h !== void 0 ? _h : 0,
                chromogenBufferScaleUl: (_k = (_j = state.presetChromogenScale) === null || _j === void 0 ? void 0 : _j.chromogenBufferScaleUl) !== null && _k !== void 0 ? _k : 0,
                hematoxylinScaleUl: (_m = (_l = state.presetChromogenScale) === null || _l === void 0 ? void 0 : _l.hemotoxylinScaleUl) !== null && _m !== void 0 ? _m : 0
            },
            miscComponent: null
        };
        return {
            _type: 'rna-cish',
            kit: kit
        };
    };
    return ChromogenKitForm;
}(React.PureComponent));
export default ChromogenKitForm;
//# sourceMappingURL=ChromogenKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ChromogenKitForm.js
// module id = 326
// module chunks = 0